import script from "./lecture.vue?vue&type=script&setup=true&lang=js"
export * from "./lecture.vue?vue&type=script&setup=true&lang=js"

import "./lecture.vue?vue&type=style&index=0&id=200b6f3c&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200b6f3c"]])

export default __exports__